import Tooltip from "@mui/material/Tooltip";
import React from "react";
import styles from "./Pill.module.css";
import { PillProps } from "../../common-types/Pill";
import { Link } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Pill: React.FC<PillProps> = ({
  variant,
  value,
  label,
  icon: Icon,
  tooltipText,
  onEntityClick,
  id,
  type,
  href,
  customOnClick,
}) => {
  const handleClick = (
    e: React.MouseEvent<HTMLSpanElement | HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (customOnClick) {
      customOnClick();
    } else if (onEntityClick) {
      onEntityClick(id ?? "", type ?? "");
    }
  };

  const renderValue = () => {
    if (href) {
      return (
        <Link
          className={`${styles["link"]} ${styles["external-link"]}`}
          to={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {value}
          <LaunchIcon className={styles["icon"]} />
        </Link>
      );
    } else if (onEntityClick || customOnClick) {
      return (
        <a className={styles["link"]} onClick={handleClick}>
          {value}
        </a>
      );
    } else {
      return <span className={styles["value"]}>{value}</span>;
    }
  };

  return (
    <div className={`${styles["container"]} ${styles[`container-${variant}`]}`}>
      {Icon && <Icon className={styles["icon"]} />}
      {label && <span className={styles["label"]}>{label}:</span>}
      {renderValue()}
      {tooltipText && (
        <Tooltip title={tooltipText} className={styles["tooltip"]}>
          <InfoOutlinedIcon className={styles["icon"]} fontSize="small" />
        </Tooltip>
      )}
    </div>
  );
};

export default Pill;
